import { render, staticRenderFns } from "./h5_manager.vue?vue&type=template&id=33aef57b&scoped=true"
import script from "./h5_manager.vue?vue&type=script&lang=ts"
export * from "./h5_manager.vue?vue&type=script&lang=ts"
import style0 from "./h5_manager.vue?vue&type=style&index=0&id=33aef57b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33aef57b",
  null
  
)

export default component.exports